export const CLEAR_CAMPAIGN = 'CLEAR_CAMPAIGN'
export const CLEAR_CAMPAIGNS = 'CLEAR_CAMPAIGNS'
export const CLEAR_CAMPAIGN_PODCASTS = 'CLEAR_CAMPAIGN_PODCASTS'
export const CLEAR_CAMPAIGN_SEASONS = 'CLEAR_CAMPAIGN_SEASONS'
export const SET_CAMPAIGN = 'SET_CAMPAIGN'
export const SET_CAMPAIGN_ADS = 'SET_CAMPAIGN_ADS'
export const SET_CAMPAIGN_EPISODES = 'SET_CAMPAIGN_EPISODES'
export const SET_CAN_CREATE_CAMPAIGN = 'SET_CAN_CREATE_CAMPAIGN'
export const SET_CAMPAIGN_COUNT = 'SET_CAMPAIGN_COUNT'
export const SET_CAMPAIGN_LIST = 'SET_CAMPAIGN_LIST'
export const SET_CAMPAIGN_PODCASTS = 'SET_CAMPAIGN_PODCASTS'
export const SET_TARGET_LIST = 'SET_TARGET_LIST'
